import Vue from 'vue';
import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';

@Module({
    namespaced: true,
    name: 'app',
    store,
    dynamic: true,
})
class AppStore extends VuexModule {
    public menuVisible: boolean = false;

    @Action({ commit: 'SHOW_MENU' })
    public ShowMenu() {
        return true;
    }

    @Action({ commit: 'HIDE_MENU' })
    public HideMenu() {
        return false;
    }

    @Mutation
    private SHOW_MENU() {
        this.menuVisible = true;
    }

    @Mutation
    private HIDE_MENU() {
        this.menuVisible = false;
    }
}

export default getModule(AppStore);
